/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useState, useEffect } from 'react';
import { colors, borderRadius, shadows, transitions } from '../../styles/theme';

const buttonStyles = css`
  position: fixed;
  bottom: 1.25rem;
  right: 1.25rem;
  width: 44px;
  height: 44px;

  @media (min-width: 768px) {
    bottom: 2rem;
    right: 2rem;
    width: 48px;
    height: 48px;
  }
  border-radius: ${borderRadius.full};
  background: linear-gradient(135deg, ${colors.primary[500]}, ${colors.primary[600]});
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${shadows.lg};
  transition: all ${transitions.normal};
  z-index: 50;
  opacity: 0;
  transform: translateY(20px);
  pointer-events: none;

  &.visible {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }

  &.visible:hover {
    transform: translateY(-3px);
    box-shadow: ${shadows.xl};
    background: linear-gradient(135deg, ${colors.primary[600]}, ${colors.primary[700]});
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      css={buttonStyles}
      className={visible ? 'visible' : ''}
      onClick={scrollToTop}
      aria-label="Sayfanın başına dön"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  );
}
